  var smBus = document.querySelector('.small-business-button');
  var enBus = document.querySelector('.enterprise-business-button');

  var smContent = document.querySelectorAll('.small-business-content');
  var enContent = document.querySelectorAll('.enterprise-business-content');

  smBus.addEventListener('click',(event)=>{
    event.preventDefault(); 
    if(smBus.classList.contains('button--secondary')){
      smBus.classList.remove('button--secondary');
      smBus.classList.add('button--primary');
    }
    if(enBus.classList.contains('button--primary')){
      enBus.classList.remove('button--primary');
      enBus.classList.add('button--secondary');
    }

      enContent.forEach(function(enb) {
        if (enb.classList.contains("active")) {
            enb.classList.remove("active");
        }
      });
      smContent.forEach(function(smb) {
        if (!smb.classList.contains("active")) {
            smb.classList.add("active");
        }
      });
  })

  enBus.addEventListener('click',(event)=>{
    event.preventDefault(); 
    if(enBus.classList.contains('button--secondary')){
      enBus.classList.remove('button--secondary');
      enBus.classList.add('button--primary');
    }
    if(smBus.classList.contains('button--primary')){
      smBus.classList.remove('button--primary');
      smBus.classList.add('button--secondary');
    }

      smContent.forEach(function(smc) {
        if (smc.classList.contains("active")) {
            smc.classList.remove("active");
        }
      });
      enContent.forEach(function(end) {
        if (!end.classList.contains("active")) {
            end.classList.add("active");
        }
      });
  })